'use strict';

module.exports = argsArray;

function argsArray(fun) {
  return function () {
    var len = arguments.length;

    if (len) {
      var args = [];
      var i = -1;

      while (++i < len) {
        args[i] = arguments[i];
      }

      return fun.call(this, args);
    } else {
      return fun.call(this, []);
    }
  };
}